import { Button, Col, Row } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { FormProvider } from "react-hook-form";

import { selectModalDirectoryCategories } from "../../../redux";
import { useDirectoryCategories } from "../hooks";
import {
  AdminMenuLayout,
  ModalDirectoryCategories,
} from "../../../shared/components";
import { WrapperCardDirectoryCategories } from "./styled";
import { TableDirectoryCategories } from "./TableDirectoryCategories";

export const DirectoryCategories = () => {
  const modalDirectoryCategories = useSelector(selectModalDirectoryCategories);
  const {
    isUpdateDirectoryCategories,
    formMethodsCreate,
    formMethodsUpdate,
    changeModalDirectoryCategoriesState,
  } = useDirectoryCategories();

  return (
    <AdminMenuLayout
      pageDescription="DirectoryCategories"
      title="DirectoryCategories"
    >
      <WrapperCardDirectoryCategories>
        <Row
          gutter={[8, 8]}
          style={{
            padding: "10px",
            width: "100%",
          }}
        >
          <Col
            span={24}
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              type="primary"
              shape="round"
              icon={<PlusOutlined />}
              size="large"
              onClick={changeModalDirectoryCategoriesState}
            >
              Agregar categoría
            </Button>
          </Col>
        </Row>
        <TableDirectoryCategories />
        {modalDirectoryCategories && isUpdateDirectoryCategories && (
          <FormProvider {...formMethodsUpdate}>
            <ModalDirectoryCategories />
          </FormProvider>
        )}
        {modalDirectoryCategories && !isUpdateDirectoryCategories && (
          <FormProvider {...formMethodsCreate}>
            <ModalDirectoryCategories />
          </FormProvider>
        )}
      </WrapperCardDirectoryCategories>
    </AdminMenuLayout>
  );
};
